export default {
    isUploading: false,
    modal: {
        revision: null,
        isOpen: false,
        data: {
            checklist: [],
            actual_duration_hours: null,
            attachments: [],
            completed_at: null,
        },
        errors: {},
    },
    confirmation: {
        isOpen: false,
        title: '',
        text: '',
        accept: null,
        acceptText: null,
        cancel: null,
        cancelText: null,
    },
    errors: {},
};
